// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0fd0957e","977":"6a0e7b0d"}[chunkId] + ".chunk.js";
};